export const paths = {
  home: '/',
  spaceflight: '/spaceflight',
  preFlight: '/preflight',
  membership: '/membership',
  newPerspective: '/new-perspective',
  pricing: '/pricing',
  adaStatement: '/ada-statement'
};
